var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("个性主题")]),_c('ThemePicker',{on:{"change":_vm.themeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }